var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-index"},[_c('HeroPd8337'),_vm._v(" "),_c('HowItWorksPd8337',{attrs:{"steps":_vm.howItWorksSteps,"enter-form-path":_vm.enterFormPath}}),_vm._v(" "),_c('FaqAccordionPd8337',{attrs:{"faq-items":_vm.faqItems,"enter-form-path":_vm.enterFormPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }